import {
  Avatar,
  Image,
  type ImageProps,
  type AvatarProps,
  type PolymorphicComponentProps,
} from "@mantine/core";

import { forwardRef } from "react";

type ImageProxyProps = PolymorphicComponentProps<"img", ImageProps>;

export const ImageProxy = forwardRef((props: ImageProxyProps, ref: any) => {
  const { src, ...rest } = props;

  // Construct the proxy URL with the image URL as a query parameter
  const proxyImageUrl = `/api/image?url=${encodeURIComponent(src)}`;

  return <Image ref={ref} {...rest} src={proxyImageUrl} />;
});

export type AvatarProxyProps = AvatarProps & { src: string; title?: string };

export const AvatarProxy = forwardRef((props: AvatarProxyProps, ref: any) => {
  const { src, ...rest } = props;

  // Construct the proxy URL with the image URL as a query parameter
  const proxyImageUrl = `/api/image?url=${encodeURIComponent(src)}`;

  return <Avatar ref={ref} {...rest} src={proxyImageUrl} />;
});
